// import Clone from "./Clone"
// import CreateSubcontract from "./CreateSubcontract"
// import Edit from "./Edit"
// import Retention from "./Retention"
import Create from './Create'

const ContractPartnerButtons = {
    Create,
}
export default ContractPartnerButtons
